import * as Sentry from "@sentry/react";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
import { SENTRY_ENVIRONMENT, SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE, SENTRY_REPLAY_SESSION_SAMPLE_RATE, SENTRY_TRACE_SAMPLE_RATE, SENTRY_SAMPLE_RATE, COMMIT_SHA } from "../constants";

export function initialiseSentry() {
	console.debug("Sentry config:", {
		environment: SENTRY_ENVIRONMENT,
		sampleRate: SENTRY_SAMPLE_RATE,
		tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
		replaysSessionSampleRate: SENTRY_REPLAY_SESSION_SAMPLE_RATE,
		replaysOnErrorSampleRate: SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE
	});

	Sentry.init({
		dsn: "https://43c478ff543749c69482d71554a42a85@o4505028829118464.ingest.sentry.io/4505035722063872",
		environment: SENTRY_ENVIRONMENT,
		release: COMMIT_SHA,
		integrations: [
			new Sentry.BrowserTracing(),
			new Sentry.Replay({
				maskAllText: false,
				maskAllInputs: false,
				blockAllMedia: false
			}),
			new CaptureConsoleIntegration({
				levels: ["error", "warn"]
			})
		],
		sampleRate: SENTRY_SAMPLE_RATE,

		// Performance Monitoring
		tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,

		// Session Replay
		replaysSessionSampleRate: SENTRY_REPLAY_SESSION_SAMPLE_RATE,
		replaysOnErrorSampleRate: SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE
	});
}
